(() => {
  const initHeader = (root = document) => {
    root.querySelectorAll('[data-cl-header]').forEach((headerShell) => {
      if (headerShell.dataset.clReady === 'true') return;
      headerShell.dataset.clReady = 'true';

      const toggle = headerShell.querySelector('[data-cl-menu-toggle]');
      const nav = headerShell.querySelector('[data-cl-nav]');
      if (!toggle || !nav) return;

      const closeMenu = () => {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-label', 'Open menu');
      };

      toggle.addEventListener('click', () => {
        const open = !nav.classList.contains('is-open');
        nav.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });

      nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));

      const cartLink = document.getElementById('cart-icon-bubble');
      const mobileCartCount = headerShell.querySelector('[data-cl-mobile-cart-count]');
      if (cartLink && mobileCartCount) {
        const syncCartCount = () => {
          const count = cartLink.querySelector('b');
          if (count) mobileCartCount.textContent = count.textContent.trim();
        };
        new MutationObserver(syncCartCount).observe(cartLink, { childList: true, subtree: true, characterData: true });
      }

      document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') closeMenu();
      });
      window.addEventListener('resize', () => {
        if (window.innerWidth > 800) closeMenu();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initHeader());
  } else {
    initHeader();
  }

  document.addEventListener('shopify:section:load', (event) => initHeader(event.target));
})();
